import {
    parse,
    parseISO,
    differenceInMinutes,
    differenceInMilliseconds,
    isBefore,
} from 'date-fns';

/**
 * Parse different date formats to Date-object
 * @param {string} dateString - Date string in different formats
 * @returns {Date|null} Date-objekt or null if invalid format
 */
export function parseFlexibleDate(dateString) {
    if (!dateString) return null;

    try {
        // Format: "2025-09-07 12:50" (without timezone)
        if (dateString.includes(' ') && !dateString.includes('T')) {
            return parse(dateString, 'yyyy-MM-dd HH:mm', new Date());
        }

        // ISO-format: "2025-09-07T15:55:00" or "2025-09-07T15:55:00.000Z"
        if (dateString.includes('T')) {
            return parseISO(dateString);
        }

        // Try to parse as ISO directly (default)
        return parseISO(dateString);
    } catch (error) {
        console.error('Error parsing date:', dateString, error);
        return null;
    }
}

/**
 * Compare two dates
 * @param {string|Date} date1
 * @param {string|Date} date2
 * @returns {object|null} Comparison result or null if any date is invalid
 */
export function compareDates(date1, date2) {
    const d1 = typeof date1 === 'string' ? parseFlexibleDate(date1) : date1;
    const d2 = typeof date2 === 'string' ? parseFlexibleDate(date2) : date2;

    if (!d1 || !d2) return null;

    return {
        isEarlier: isBefore(d1, d2),
        differenceMs: differenceInMilliseconds(d2, d1),
        differenceMinutes: differenceInMinutes(d2, d1),
    };
}
